import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
@Directive({
  selector: '[validateMax]',
  providers: [
    {
        provide: NG_VALIDATORS,
        useExisting: MaxOffsetDirectiveDirective,
        multi: true
    }
]
})
export class MaxOffsetDirectiveDirective implements Validator{

  @Input('validateMax') max: number | null;

    validate(c: AbstractControl): ValidationErrors | null {
        if (this.max === null || this.max === undefined) {
            return null;
        }
        return Number(c.value) <= Number(this.max) ? null : { validateMax: true };
    }
}
